<template>
  <div>
    <v-text-field
      :label="label"
      v-model="value"
      @click="dialog = true"
      :hint="hint"
      :persistent-hint="hint != ''"
      :rules="[required ? validation.required : true]"
    ></v-text-field>
    <!-- モーダル部分  --->
    <v-dialog v-model="dialog" :max-width="maxWidth">
      <v-card>
        <v-card-actions>
          <v-container>
            <div class="text-center">
              <v-form ref="form" v-model="valid">
                <v-row>
                  自動で保存されます setCols.vue
                </v-row>
                <v-row>
                  <v-col cols="3">
                    <v-select
                      v-model.number="colSet.lg"
                      label="デスクトップ"
                      hint="1264px ～ 1904px"
                      :items="selectbox"
                      item-text="label"
                      item-value="value"
                      persistent-hint
                    ></v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-select
                      v-model.number="colSet.md"
                      label="大型タブレット～ノートパソコン"
                      hint="960px～1264px"
                      :items="selectbox"
                      item-text="label"
                      item-value="value"
                      persistent-hint
                    ></v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-select
                      v-model.number="colSet.sm"
                      label="小～中型タブレット"
                      hint="600px～960px"
                      :items="selectbox"
                      item-text="label"
                      item-value="value"
                      persistent-hint
                    ></v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-select
                      v-model.number="colSet.xs"
                      label="スマホ"
                      hint="～600px"
                      :items="selectbox"
                      item-text="label"
                      item-value="value"
                      persistent-hint
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-btn color="primary white--text " @click="onSet">
                    共通
                  </v-btn>
                </v-row>
                <v-row class="mt-8">
                  <h5>おススメColsセット</h5>
                </v-row>

                <v-row>
                  <v-col cols="3">
                    <v-card @click="onCustomSet(6, 12)" color="green lighten-4">
                      <v-row>
                        <v-col cols="9" class="pa-2">大型モニター</v-col>
                        <v-col cols="3" class="pl-0 pt-2">6</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="9" class="pa-2 pt-0 pb-0">
                          小型モニター
                        </v-col>
                        <v-col cols="3" class="pl-0 pt-0 pb-0">12</v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col cols="3">
                    <v-card @click="onCustomSet(4, 12)" color="green lighten-4">
                      <v-row>
                        <v-col cols="9" class="pa-2">大型モニター</v-col>
                        <v-col cols="3" class="pl-0 pt-2">4</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="9" class="pa-2 pt-0 pb-0">
                          小型モニター
                        </v-col>
                        <v-col cols="3" class="pl-0 pt-0 pb-0">12</v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col cols="3">
                    <v-card @click="onCustomSet(3, 12)" color="green lighten-4">
                      <v-row>
                        <v-col cols="9" class="pa-2">大型モニター</v-col>
                        <v-col cols="3" class="pl-0 pt-2">3</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="9" class="pa-2 pt-0 pb-0">
                          小型モニター
                        </v-col>
                        <v-col cols="3" class="pl-0 pt-0 pb-0">12</v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row class="mt-6">
                  <v-col cols="3">
                    <v-card @click="onCustomSet(6, 6)" color="green lighten-4">
                      <v-row>
                        <v-col cols="9" class="pa-2">大型モニター</v-col>
                        <v-col cols="3" class="pl-0 pt-2">6</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="9" class="pa-2 pt-0 pb-0">
                          小型モニター
                        </v-col>
                        <v-col cols="3" class="pl-0 pt-0 pb-0">6</v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col cols="3">
                    <v-card @click="onCustomSet(4, 6)" color="green lighten-4">
                      <v-row>
                        <v-col cols="9" class="pa-2">大型モニター</v-col>
                        <v-col cols="3" class="pl-0 pt-2">4</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="9" class="pa-2 pt-0 pb-0">
                          小型モニター
                        </v-col>
                        <v-col cols="3" class="pl-0 pt-0 pb-0">6</v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col cols="3">
                    <v-card @click="onCustomSet(3, 6)" color="green lighten-4">
                      <v-row>
                        <v-col cols="9" class="pa-2">大型モニター</v-col>
                        <v-col cols="3" class="pl-0 pt-2">3</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="9" class="pa-2 pt-0 pb-0">
                          小型モニター
                        </v-col>
                        <v-col cols="3" class="pl-0 pt-0 pb-0">6</v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row class="mt-6">
                  <v-col cols="3">
                    <v-card @click="onCustomSet(13, 13)" color="cyan lighten-4">
                      <v-row>
                        <v-col cols="8" class="pa-2">共通</v-col>
                        <v-col cols="4" class="pl-0 pt-2">auto</v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col cols="3">
                    <v-card @click="onCustomSet(12, 12)" color="cyan lighten-4">
                      <v-row>
                        <v-col cols="9" class="pa-2">共通</v-col>
                        <v-col cols="3" class="pl-0 pt-2">12</v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col cols="3">
                    <v-card @click="onCustomSet(6, 6)" color="cyan lighten-4">
                      <v-row>
                        <v-col cols="9" class="pa-2">共通</v-col>
                        <v-col cols="3" class="pl-0 pt-2">6</v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col cols="3">
                    <v-card @click="onCustomSet(4, 4)" color="cyan lighten-4">
                      <v-row>
                        <v-col cols="9" class="pa-2">共通</v-col>
                        <v-col cols="3" class="pl-0 pt-2">4</v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-form>
            </div>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: { required: true },
    label: { type: String, default: "colサイズの指定" },
    required: { type: Boolean, default: true },
    hint: { type: String, default: "" },
    maxWidth: { type: String, default: "700px" },
  },
  watch: {
    colSet: {
      handler(value) {
        this.$emit("set", JSON.stringify(value));
      },
      deep: true,
    },
  },
  data() {
    return {
      returnData: {
        value: this.value,
      },
      validation: {
        required: (value) => !!value || "必須項目です",
      },
      //
      colSet: {
        lg: 0,
        md: 0,
        sm: 0,
        xs: 0,
      },
      //
      selectbox: [
        { label: "0", value: 0 },
        { label: "1", value: 1 },
        { label: "2", value: 2 },
        { label: "3", value: 3 },
        { label: "4", value: 4 },
        { label: "5", value: 5 },
        { label: "6", value: 6 },
        { label: "7", value: 7 },
        { label: "8", value: 8 },
        { label: "9", value: 9 },
        { label: "10", value: 10 },
        { label: "11", value: 11 },
        { label: "12", value: 12 },
        { label: "auto", value: 13 },
      ],
      //
      valid: true,
      dialog: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    onSet() {
      [this.colSet.md, this.colSet.sm, this.colSet.xs] = [
        this.colSet.lg,
        this.colSet.lg,
        this.colSet.lg,
      ];
      this.dialog = false;
    },
    onCustomSet(bigSet, smallSet) {
      this.colSet.lg = bigSet;
      this.colSet.md = bigSet;
      this.colSet.sm = smallSet;
      this.colSet.xs = smallSet;

      this.dialog = false;
    },
    init() {
      if (isNaN(this.value) && this.value != "auto") {
        this.colSet = JSON.parse(this.value);
      } else {
        let d = 0;
        if (this.value == "auto") {
          d = 13;
        } else if (this.value == "") {
          d = 0;
        } else {
          d = Number(this.value);
        }
        [this.colSet.lg, this.colSet.md, this.colSet.sm, this.colSet.xs] = [
          d,
          d,
          d,
          d,
        ];
      }
    },
  },
};
</script>

<style>
.custom-label-color input {
  color: black !important;
}
</style>
